import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface MushroomSketch {
  id: number;
  x: number;
  y: number;
  type: 'lions-mane' | 'cordyceps' | 'reishi';
  rotation: number;
  scale: number;
}
export function ScrollSpiceExplosions() {
  const [mushrooms, setMushrooms] = useState<MushroomSketch[]>([]);
  const [lastScrollY, setLastScrollY] = useState(0);
  const mushroomTypes: Array<'lions-mane' | 'cordyceps' | 'reishi'> = ['lions-mane', 'cordyceps', 'reishi'];
  useEffect(() => {
    let mushroomId = 0;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDelta = Math.abs(currentScrollY - lastScrollY);
      if (scrollDelta > 250) {
        const randomX = Math.random() * window.innerWidth;
        const randomY = currentScrollY + Math.random() * window.innerHeight;
        const randomType = mushroomTypes[Math.floor(Math.random() * mushroomTypes.length)];
        const randomRotation = Math.random() * 360;
        const randomScale = 0.6 + Math.random() * 0.8;
        const newMushroom: MushroomSketch = {
          id: mushroomId++,
          x: randomX,
          y: randomY,
          type: randomType,
          rotation: randomRotation,
          scale: randomScale
        };
        setMushrooms(prev => [...prev, newMushroom]);
        setLastScrollY(currentScrollY);
        setTimeout(() => {
          setMushrooms(prev => prev.filter(m => m.id !== newMushroom.id));
        }, 4000);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  const LionsMane = () => <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-324">
      <path d="M60 20C45 20 35 30 35 45C35 50 36 55 38 59M60 20C75 20 85 30 85 45C85 50 84 55 82 59" stroke="black" strokeWidth="1.5" strokeLinecap="round" data-id="element-325" />
      <path d="M38 59C40 65 45 70 50 75C52 77 54 79 56 81M82 59C80 65 75 70 70 75C68 77 66 79 64 81" stroke="black" strokeWidth="1.5" strokeLinecap="round" data-id="element-326" />
      <path d="M45 45C45 48 47 50 50 52M75 45C75 48 73 50 70 52" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-327" />
      <path d="M56 81L60 95L64 81" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-328" />
      <ellipse cx="60" cy="40" rx="15" ry="20" stroke="black" strokeWidth="1" data-id="element-329" />
      <path d="M50 35C52 32 55 30 60 30C65 30 68 32 70 35" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-330" />
    </svg>;
  const Cordyceps = () => <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-331">
      <path d="M60 90C60 90 58 70 58 50C58 35 60 20 60 20" stroke="black" strokeWidth="2" strokeLinecap="round" data-id="element-332" />
      <path d="M60 20C60 20 62 35 62 50C62 70 60 90 60 90" stroke="black" strokeWidth="1.5" strokeLinecap="round" data-id="element-333" />
      <circle cx="60" cy="20" r="5" stroke="black" strokeWidth="1.5" data-id="element-334" />
      <path d="M45 60C47 58 50 57 55 58M75 60C73 58 70 57 65 58" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-335" />
      <path d="M48 45C50 43 53 42 57 43M72 45C70 43 67 42 63 43" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-336" />
      <path d="M50 75C52 73 55 72 58 73M70 75C68 73 65 72 62 73" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-337" />
    </svg>;
  const Reishi = () => <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-338">
      <path d="M30 70C30 50 40 35 60 35C80 35 90 50 90 70" stroke="black" strokeWidth="2" strokeLinecap="round" data-id="element-339" />
      <path d="M35 70C35 55 45 42 60 42C75 42 85 55 85 70" stroke="black" strokeWidth="1.5" strokeLinecap="round" data-id="element-340" />
      <path d="M40 70C40 58 48 48 60 48C72 48 80 58 80 70" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-341" />
      <line x1="60" y1="70" x2="60" y2="95" stroke="black" strokeWidth="2" strokeLinecap="round" data-id="element-342" />
      <path d="M30 70L35 72L40 70L45 72L50 70L55 72L60 70L65 72L70 70L75 72L80 70L85 72L90 70" stroke="black" strokeWidth="1" strokeLinecap="round" data-id="element-343" />
    </svg>;
  const renderMushroom = (type: string) => {
    switch (type) {
      case 'lions-mane':
        return <LionsMane data-id="element-344" />;
      case 'cordyceps':
        return <Cordyceps data-id="element-345" />;
      case 'reishi':
        return <Reishi data-id="element-346" />;
      default:
        return <LionsMane data-id="element-347" />;
    }
  };
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-348">
      <AnimatePresence data-id="element-349">
        {mushrooms.map(mushroom => <motion.div key={mushroom.id} initial={{
        opacity: 0,
        scale: 0,
        rotate: mushroom.rotation
      }} animate={{
        opacity: 0.15,
        scale: mushroom.scale,
        rotate: mushroom.rotation
      }} exit={{
        opacity: 0,
        scale: 0
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} className="absolute" style={{
        left: mushroom.x,
        top: mushroom.y,
        transform: 'translate(-50%, -50%)'
      }} data-id="element-350">
            {renderMushroom(mushroom.type)}
          </motion.div>)}
      </AnimatePresence>
    </div>;
}